import Component from 'vue-class-component';

// 注册组件内生命周期钩子
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);
